(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tabs-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('categoryTabChange', function (e) {
    var index = e.detail.index;
    document.querySelectorAll('.category-tabs-footer').forEach(function (wrapper) {
      wrapper.querySelectorAll('.category-tabs-footer__item').forEach(function (el) {
        el.classList.toggle('is-hidden', parseInt(el.getAttribute('data-index'), 10) !== index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-tabs"] && !Shopify.designMode) return;
  try {
    
  function showCategoryTab(wrapper, index) {
    wrapper.querySelectorAll('.category-tabs__item').forEach(function (item) {
      var isActive = parseInt(item.getAttribute('data-index'), 10) === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    wrapper.querySelectorAll('.category-tabs__footer').forEach(function (el) {
      el.classList.toggle('is-hidden', parseInt(el.getAttribute('data-index'), 10) !== index);
    });

    var tabCount = parseInt(wrapper.getAttribute('data-tab-count'), 10);
    var ownSection = wrapper.closest('[id^="shopify-section-"]');
    if (!ownSection) return;

    var next = ownSection.nextElementSibling;
    var count = 0;
    while (next && count < tabCount) {
      if (next.id && next.id.indexOf('shopify-section-') === 0) {
        next.style.display = count === index ? '' : 'none';
        count++;
      }
      next = next.nextElementSibling;
    }

    document.dispatchEvent(new CustomEvent('categoryTabChange', { detail: { index: index } }));
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.category-tabs__item');
    if (!tab) return;
    var wrapper = tab.closest('.category-tabs');
    var index = parseInt(tab.getAttribute('data-index'), 10);
    showCategoryTab(wrapper, index);
  });

  document.querySelectorAll('.category-tabs').forEach(function (wrapper) {
    showCategoryTab(wrapper, 0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
